import React from 'react';
export function DifferenceSection() {
  return <section className="py-24 md:py-32 bg-muted" data-id="element-55">
      <div className="container mx-auto px-4 md:px-8" data-id="element-56">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center max-w-7xl mx-auto" data-id="element-57">
          {/* Image Column */}
          <div className="order-2 lg:order-1 relative h-[500px] lg:h-[700px] w-full overflow-hidden" data-id="element-58">
            <img src="https://cdn.magicpatterns.com/uploads/pcfmcnB9CszER8H389NKwx/halo-laser-be-clinical-2.jpg" alt="Halo laser treatment being performed on a patient" className="w-full h-full object-cover" data-id="element-59" />
          </div>

          {/* Text Column */}
          <div className="order-1 lg:order-2 flex flex-col justify-center" data-id="element-60">
            <span className="text-sage font-sans font-bold uppercase tracking-[0.2em] text-sm mb-6" data-id="element-61">
              Why Halo Is Different
            </span>

            <h2 className="text-3xl md:text-5xl font-serif text-foreground leading-tight mb-8" data-id="element-62">
              No filler. No freezing. Just your skin — doing what it was
              designed to do.
            </h2>

            <p className="text-lg text-foreground/70 font-sans leading-relaxed mb-12" data-id="element-63">
              Halo is a hybrid fractional laser — the only one of its kind. It
              delivers two wavelengths simultaneously: one that works on the
              surface, one that works deep. The result is your skin activating
              its own collagen, shedding old damage, and rebuilding from within.
              No foreign substances. No altered expression. Just renewal.
            </p>

            {/* Badges */}
            <div className="flex flex-wrap gap-4" data-id="element-64">
              {['Regenerative', 'Non-Surgical', 'Zero Foreign Substances'].map((badge, i) => <div key={i} className="px-5 py-2 border border-divider bg-background text-foreground text-sm font-sans tracking-wide uppercase" data-id="element-65">
                    {badge}
                  </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}